import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EXCHANGE_EVENT_TYPES, setCompetition, setEventType, useAppDispatch } from "@hypexone/uicore";
import SportCompetitionsSection from "./SportCompetitionsSection";
import ChevronRightIconBorder from "../../../assets/icons/chevron-right-icon-border.svg";
import ChevronDownIconBorderBlue from "../../../assets/icons/chevron-down-icon-border-blue.svg";

const getActiveSportSlug = (pathname: string): string | null => {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "exchange_sports") return null;
  if (parts[1] === "sports" && parts[2]) return parts[2];
  if (parts[1] && parts[1] !== "virtuals") return parts[1];
  return null;
};

const Sidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [allSportsOpen, setAllSportsOpen] = useState(false);
  const dispatch = useAppDispatch();
  const activeSlug = getActiveSportSlug(pathname);
  const activeSport = EXCHANGE_EVENT_TYPES.find(
    (s) => s.slug === activeSlug
  ) ?? null;

  const showActiveSportSection =
    activeSlug &&
    activeSport &&
    (pathname === `/exchange_sports/${activeSlug}` ||
      pathname === `/exchange_sports/sports/${activeSlug}` ||
      pathname.startsWith(`/exchange_sports/${activeSlug}/`) ||
      pathname.startsWith(`/exchange_sports/sports/${activeSlug}/`));

  return (
    <div className="min-w-28 flex flex-col">
      {/* Sports header */}
      <div className="bg-black text-white px-3 py-2 border-b-2 border-goldenYellow text-[13px]">
        Sports
      </div>

      {/* All Sports accordion */}
      <div className="border-b border-goldenYellow">
        <button
          type="button"
          onClick={() => setAllSportsOpen((o) => !o)}
          className="flex justify-between items-center w-full bg-white text-black px-3 py-1 text-left hover:bg-gray1 cursor-pointer text-[13px] border-b border-black"
        >
          <span className="flex-1">All Sports</span>
          <span className="flex-shrink-0">
            {allSportsOpen ? (
              <img
                src={ChevronDownIconBorderBlue}
                alt="down"
                className="h-[15px] w-[15px]"
              />
            ) : (
              <img
                src={ChevronRightIconBorder}
                alt="right"
                className="h-[15px] w-[15px]"
              />
            )}
          </span>
        </button>
        {allSportsOpen && (
          <div className="bg-white">
            {EXCHANGE_EVENT_TYPES.map(({ id, name, slug }) => (
              <button
                key={id}
                type="button"
                onClick={() => {
                  setAllSportsOpen(false);
                  dispatch(setCompetition({ id: "", name: "", slug: "" }));
                  dispatch(setEventType({ id, name, slug }));
                  navigate(`/exchange_sports/${slug}`);
                }}
                className="w-full text-left px-3 py-1 text-black border-b border-goldenYellow last:border-b-0 hover:bg-gray1 cursor-pointer capitalize text-[13px]"
              >
                {name}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Active sport: Top Competitions + list (when on /exchange_sports/:eventType) */}
      {showActiveSportSection && activeSport && (
        <SportCompetitionsSection
          sportId={activeSport.id}
          sportName={activeSport.name}
        />
      )}
    </div>
  );
};

export default Sidebar;
